import React, { Suspense } from 'react';
import ReactDOM from 'react-dom';
import './index.scss';
import { BrowserRouter } from 'react-router-dom';
import App from './app/App';
import reportWebVitals from './reportWebVitals';
import ErrorBoundary from './app/shared/components/error-boundary';
import setRem from '../src/app/shared/utilities/rem';

setRem();

ReactDOM.render(
    // <React.StrictMode>
    <BrowserRouter basename='/page/single-pages'>
        <ErrorBoundary>
            <Suspense fallback={<div>Loading...</div>}>
                <App />
            </Suspense>
        </ErrorBoundary>
    </BrowserRouter>,
    // </React.StrictMode>,
    document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// eslint-disable-next-line no-console
reportWebVitals(console.log);
